import { connect } from 'react-redux'
import { PANTALLA_INDICE_ID, actions, selectors, GestorSesionesContainer } from 'ibook-api'
import PantallaPortada from '../components/pantalla-portada'

export default connect(
    (state, ownProps) => ({
        GestorSesiones: GestorSesionesContainer,
        configPortada: selectors.getConfigPortada(state)
    }),
    (dispatch, ownProps) => ({
        onAccion: accion => {
            // const { onPantalla, onZona } = props
    
            if (accion.indice) {
                // onPantalla(PANTALLA_INDICE_ID, { libroId: accion.indice })
                dispatch(actions.pantalla(PANTALLA_INDICE_ID, { libroId: accion.indice } ))
            } else if (accion.pantalla) {
                // onPantalla(accion.pantalla, accion.props || {})
                dispatch(actions.pantalla(accion.pantalla, accion.props || {}))
            } else if (accion.zona) {
                // onZona(accion.zona)
                const libroId = accion.zona.substring(0, 2)
                const numPagina = Number(accion.zona.substring(2, 5))
                const numZona = Number(accion.zona.split('.')[1])
                dispatch(actions.zona(libroId, numPagina, numZona))
            }
        },
        onMostrarGestorSesiones: () => dispatch(actions.activarSesion(null))
        // onPantalla: (pantallaId, props) => dispatch(actions.pantalla(pantallaId, props)),
        // onZona: (zonaId) => {
        //     const libroId = zonaId.substring(0, 2)
        //     const numPagina = Number(zonaId.substring(2, 5))
        //     const numZona = Number(zonaId.split('.')[1])
        //     dispatch(actions.zona(libroId, numPagina, numZona))
        // }
    })
)(PantallaPortada)